{
  "context": {
    "filters": {
      "from": "2026-08-03T00:00:00Z",
      "to": "2026-11-02T00:00:00Z",
      "gated": "gated",
      "excludePasteHeavy": false,
      "excludeFirstTryPasses": false,
      "moduleIds": []
    },
    "releaseLines": [
      {
        "at": "2026-08-10",
        "prompt": "tutor/evaluate_draft.md",
        "label": "New release \u00b7 tutor/evaluate_draft.md"
      },
      {
        "at": "2026-09-07",
        "prompt": "tutor/evaluate_single_dimension.md",
        "label": "New release \u00b7 tutor/evaluate_single_dimension.md"
      },
      {
        "at": "2026-10-05",
        "prompt": "tutor/formative_hint.md",
        "label": "New release \u00b7 tutor/formative_hint.md"
      }
    ],
    "minN": 30
  },
  "figures": [
    {
      "name": "ai_assist_scope",
      "shape": "number",
      "unit": "count",
      "value": 468.0,
      "extras": {
        "n": 468,
        "nStudents": 468,
        "tooFew": false,
        "weekly": [
          {
            "x": "2026-08-03",
            "value": 36.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-10",
            "value": 36.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-17",
            "value": 36.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-24",
            "value": 36.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-31",
            "value": 36.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-07",
            "value": 36.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-14",
            "value": 36.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-21",
            "value": 36.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-28",
            "value": 36.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-05",
            "value": 36.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-12",
            "value": 36.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-19",
            "value": 36.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-26",
            "value": 36.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          }
        ],
        "p20": null,
        "p80": null,
        "parts": null,
        "at": null
      }
    },
    {
      "name": "attempts_to_done",
      "shape": "number",
      "unit": "attempts",
      "value": 9.0,
      "extras": {
        "n": 468,
        "nStudents": 468,
        "tooFew": false,
        "weekly": [
          {
            "x": "2026-08-03",
            "value": 8.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-10",
            "value": 9.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-17",
            "value": 10.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-24",
            "value": 8.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-31",
            "value": 9.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-07",
            "value": 10.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-14",
            "value": 8.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-21",
            "value": 9.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-28",
            "value": 10.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-05",
            "value": 8.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-12",
            "value": 9.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-19",
            "value": 10.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-26",
            "value": 8.0,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          }
        ],
        "p20": null,
        "p80": null,
        "parts": null,
        "at": null
      }
    },
    {
      "name": "score_gain_per_attempt",
      "shape": "number",
      "unit": "pp",
      "value": 9.965701736535085,
      "extras": {
        "n": 468,
        "nStudents": 468,
        "tooFew": false,
        "weekly": [
          {
            "x": "2026-08-03",
            "value": 10.626984126984134,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-10",
            "value": 9.875,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-17",
            "value": 9.154320987654323,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-24",
            "value": 10.80158730158731,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-31",
            "value": 9.722222222222221,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-07",
            "value": 9.290123456790127,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-14",
            "value": 10.626984126984134,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-21",
            "value": 9.875,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-28",
            "value": 9.222222222222225,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-05",
            "value": 10.539682539682547,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-12",
            "value": 9.95138888888889,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-19",
            "value": 9.154320987654323,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-26",
            "value": 10.714285714285722,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          }
        ],
        "p20": null,
        "p80": null,
        "parts": null,
        "at": null
      }
    },
    {
      "name": "helpful_share",
      "shape": "number",
      "unit": "%",
      "value": 67.91958041958041,
      "extras": {
        "n": 1144,
        "nStudents": 468,
        "tooFew": false,
        "weekly": [
          {
            "x": "2026-08-03",
            "value": 63.888888888888886,
            "extras": {
              "n": 72,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-10",
            "value": 67.77777777777779,
            "extras": {
              "n": 90,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-17",
            "value": 71.42857142857143,
            "extras": {
              "n": 84,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-24",
            "value": 62.5,
            "extras": {
              "n": 96,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-31",
            "value": 73.75,
            "extras": {
              "n": 80,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-07",
            "value": 66.36363636363637,
            "extras": {
              "n": 110,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-14",
            "value": 70.0,
            "extras": {
              "n": 70,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-21",
            "value": 63.0,
            "extras": {
              "n": 100,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-28",
            "value": 71.7948717948718,
            "extras": {
              "n": 78,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-05",
            "value": 67.3469387755102,
            "extras": {
              "n": 98,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-12",
            "value": 75.0,
            "extras": {
              "n": 76,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-19",
            "value": 65.38461538461539,
            "extras": {
              "n": 104,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-26",
            "value": 68.6046511627907,
            "extras": {
              "n": 86,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          }
        ],
        "p20": null,
        "p80": null,
        "parts": null,
        "at": null
      }
    },
    {
      "name": "vote_rate",
      "shape": "number",
      "unit": "%",
      "value": 27.39463601532567,
      "extras": {
        "n": 4176,
        "nStudents": 468,
        "tooFew": false,
        "weekly": [
          {
            "x": "2026-08-03",
            "value": 25.0,
            "extras": {
              "n": 288,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-10",
            "value": 27.77777777777778,
            "extras": {
              "n": 324,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-17",
            "value": 23.333333333333332,
            "extras": {
              "n": 360,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-24",
            "value": 33.33333333333333,
            "extras": {
              "n": 288,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-31",
            "value": 24.691358024691358,
            "extras": {
              "n": 324,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-07",
            "value": 30.555555555555557,
            "extras": {
              "n": 360,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-14",
            "value": 24.305555555555554,
            "extras": {
              "n": 288,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-21",
            "value": 30.864197530864196,
            "extras": {
              "n": 324,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-28",
            "value": 21.666666666666668,
            "extras": {
              "n": 360,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-05",
            "value": 34.02777777777778,
            "extras": {
              "n": 288,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-12",
            "value": 23.456790123456788,
            "extras": {
              "n": 324,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-19",
            "value": 28.888888888888886,
            "extras": {
              "n": 360,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-26",
            "value": 29.86111111111111,
            "extras": {
              "n": 288,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          }
        ],
        "p20": null,
        "p80": null,
        "parts": null,
        "at": null
      }
    },
    {
      "name": "paste_heavy_share",
      "shape": "number",
      "unit": "%",
      "value": 15.598290598290598,
      "extras": {
        "n": 468,
        "nStudents": 468,
        "tooFew": false,
        "weekly": [
          {
            "x": "2026-08-03",
            "value": 13.88888888888889,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-10",
            "value": 16.666666666666664,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-17",
            "value": 13.88888888888889,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-24",
            "value": 19.444444444444446,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-08-31",
            "value": 11.11111111111111,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-07",
            "value": 19.444444444444446,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-14",
            "value": 13.88888888888889,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-21",
            "value": 16.666666666666664,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-09-28",
            "value": 16.666666666666664,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-05",
            "value": 11.11111111111111,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-12",
            "value": 19.444444444444446,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-19",
            "value": 13.88888888888889,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          },
          {
            "x": "2026-10-26",
            "value": 16.666666666666664,
            "extras": {
              "n": 36,
              "nStudents": 36,
              "tooFew": false,
              "weekly": null,
              "p20": null,
              "p80": null,
              "parts": null,
              "at": null
            }
          }
        ],
        "p20": null,
        "p80": null,
        "parts": null,
        "at": null
      }
    },
    {
      "name": "stuck_students",
      "shape": "number",
      "unit": "count",
      "value": 7.0,
      "extras": {
        "n": 7,
        "nStudents": 7,
        "tooFew": true,
        "weekly": null,
        "p20": null,
        "p80": null,
        "parts": null,
        "at": null
      }
    },
    {
      "name": "score_by_attempt",
      "shape": "points",
      "unit": "%",
      "axis": "attempt",
      "value": [
        {
          "x": 1,
          "value": 45.0,
          "extras": {
            "n": 468,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": 34.0,
            "p80": 68.0,
            "parts": {
              "32": 42.0,
              "33": 39.0,
              "34": 46.0,
              "35": 41.0,
              "36": 40.0,
              "44": 15.0,
              "45": 17.0,
              "46": 13.0,
              "47": 13.0,
              "48": 15.0,
              "66": 37.0,
              "67": 37.0,
              "68": 35.0,
              "69": 39.0,
              "70": 39.0
            },
            "at": null
          }
        },
        {
          "x": 2,
          "value": 96.0,
          "extras": {
            "n": 468,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": 43.0,
            "p80": 99.0,
            "parts": {
              "41": 42.0,
              "42": 39.0,
              "43": 46.0,
              "44": 41.0,
              "45": 40.0,
              "96": 52.0,
              "97": 54.0,
              "98": 48.0,
              "99": 52.0,
              "100": 54.0
            },
            "at": null
          }
        },
        {
          "x": 3,
          "value": 126.0,
          "extras": {
            "n": 468,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": 52.0,
            "p80": 129.0,
            "parts": {
              "50": 42.0,
              "51": 39.0,
              "52": 46.0,
              "53": 41.0,
              "54": 40.0,
              "126": 52.0,
              "127": 54.0,
              "128": 48.0,
              "129": 52.0,
              "130": 54.0
            },
            "at": null
          }
        },
        {
          "x": 4,
          "value": 144.0,
          "extras": {
            "n": 468,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": 61.0,
            "p80": 147.0,
            "parts": {
              "59": 42.0,
              "60": 39.0,
              "61": 46.0,
              "62": 41.0,
              "63": 40.0,
              "144": 52.0,
              "145": 54.0,
              "146": 48.0,
              "147": 52.0,
              "148": 54.0
            },
            "at": null
          }
        },
        {
          "x": 5,
          "value": 144.0,
          "extras": {
            "n": 468,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": 70.0,
            "p80": 147.0,
            "parts": {
              "68": 42.0,
              "69": 39.0,
              "70": 46.0,
              "71": 41.0,
              "72": 40.0,
              "144": 52.0,
              "145": 54.0,
              "146": 48.0,
              "147": 52.0,
              "148": 54.0
            },
            "at": null
          }
        },
        {
          "x": 6,
          "value": 144.0,
          "extras": {
            "n": 468,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": 79.0,
            "p80": 147.0,
            "parts": {
              "77": 42.0,
              "78": 39.0,
              "79": 46.0,
              "80": 41.0,
              "81": 40.0,
              "144": 52.0,
              "145": 54.0,
              "146": 48.0,
              "147": 52.0,
              "148": 54.0
            },
            "at": null
          }
        },
        {
          "x": 7,
          "value": 144.0,
          "extras": {
            "n": 468,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": 88.0,
            "p80": 147.0,
            "parts": {
              "86": 42.0,
              "87": 39.0,
              "88": 46.0,
              "89": 41.0,
              "90": 40.0,
              "144": 52.0,
              "145": 54.0,
              "146": 48.0,
              "147": 52.0,
              "148": 54.0
            },
            "at": null
          }
        },
        {
          "x": 8,
          "value": 144.0,
          "extras": {
            "n": 468,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": 97.0,
            "p80": 147.0,
            "parts": {
              "95": 42.0,
              "96": 39.0,
              "97": 46.0,
              "98": 41.0,
              "99": 40.0,
              "144": 52.0,
              "145": 54.0,
              "146": 48.0,
              "147": 52.0,
              "148": 54.0
            },
            "at": null
          }
        },
        {
          "x": 9,
          "value": 144.0,
          "extras": {
            "n": 468,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": 104.0,
            "p80": 147.0,
            "parts": {
              "95": 17.0,
              "96": 15.0,
              "97": 17.0,
              "98": 16.0,
              "99": 15.0,
              "104": 25.0,
              "105": 24.0,
              "106": 29.0,
              "107": 25.0,
              "108": 25.0,
              "144": 52.0,
              "145": 54.0,
              "146": 48.0,
              "147": 52.0,
              "148": 54.0
            },
            "at": null
          }
        },
        {
          "x": 10,
          "value": 144.0,
          "extras": {
            "n": 468,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": 105.0,
            "p80": 147.0,
            "parts": {
              "95": 17.0,
              "96": 15.0,
              "97": 17.0,
              "98": 16.0,
              "99": 15.0,
              "104": 13.0,
              "105": 12.0,
              "106": 14.0,
              "107": 13.0,
              "108": 12.0,
              "113": 12.0,
              "114": 12.0,
              "115": 15.0,
              "116": 12.0,
              "117": 13.0,
              "144": 52.0,
              "145": 54.0,
              "146": 48.0,
              "147": 52.0,
              "148": 54.0
            },
            "at": null
          }
        }
      ],
      "extras": {
        "n": null,
        "nStudents": null,
        "tooFew": null,
        "weekly": null,
        "p20": null,
        "p80": null,
        "parts": null,
        "at": null
      }
    },
    {
      "name": "score_by_session_week",
      "shape": "points",
      "unit": "%",
      "axis": "sessionWeek",
      "value": [
        {
          "x": 1,
          "value": 144.0,
          "extras": {
            "n": 468,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": 105.0,
            "p80": 147.0,
            "parts": {
              "95": 17.0,
              "96": 15.0,
              "97": 17.0,
              "98": 16.0,
              "99": 15.0,
              "104": 13.0,
              "105": 12.0,
              "106": 14.0,
              "107": 13.0,
              "108": 12.0,
              "113": 12.0,
              "114": 12.0,
              "115": 15.0,
              "116": 12.0,
              "117": 13.0,
              "144": 52.0,
              "145": 54.0,
              "146": 48.0,
              "147": 52.0,
              "148": 54.0
            },
            "at": null
          }
        }
      ],
      "extras": {
        "n": null,
        "nStudents": null,
        "tooFew": null,
        "weekly": null,
        "p20": null,
        "p80": null,
        "parts": null,
        "at": null
      }
    },
    {
      "name": "helpful_votes:week",
      "shape": "points",
      "unit": "count",
      "axis": "week",
      "value": [
        {
          "x": "2026-08-03",
          "value": 46.0,
          "extras": {
            "n": 72,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": {
              "helpful": 46.0,
              "notHelpful": 26.0
            },
            "at": null
          }
        },
        {
          "x": "2026-08-10",
          "value": 61.0,
          "extras": {
            "n": 90,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": {
              "helpful": 61.0,
              "notHelpful": 29.0
            },
            "at": null
          }
        },
        {
          "x": "2026-08-17",
          "value": 60.0,
          "extras": {
            "n": 84,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": {
              "helpful": 60.0,
              "notHelpful": 24.0
            },
            "at": null
          }
        },
        {
          "x": "2026-08-24",
          "value": 60.0,
          "extras": {
            "n": 96,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": {
              "helpful": 60.0,
              "notHelpful": 36.0
            },
            "at": null
          }
        },
        {
          "x": "2026-08-31",
          "value": 59.0,
          "extras": {
            "n": 80,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": {
              "helpful": 59.0,
              "notHelpful": 21.0
            },
            "at": null
          }
        },
        {
          "x": "2026-09-07",
          "value": 73.0,
          "extras": {
            "n": 110,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": {
              "helpful": 73.0,
              "notHelpful": 37.0
            },
            "at": null
          }
        },
        {
          "x": "2026-09-14",
          "value": 49.0,
          "extras": {
            "n": 70,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": {
              "helpful": 49.0,
              "notHelpful": 21.0
            },
            "at": null
          }
        },
        {
          "x": "2026-09-21",
          "value": 63.0,
          "extras": {
            "n": 100,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": {
              "helpful": 63.0,
              "notHelpful": 37.0
            },
            "at": null
          }
        },
        {
          "x": "2026-09-28",
          "value": 56.0,
          "extras": {
            "n": 78,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": {
              "helpful": 56.0,
              "notHelpful": 22.0
            },
            "at": null
          }
        },
        {
          "x": "2026-10-05",
          "value": 66.0,
          "extras": {
            "n": 98,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": {
              "helpful": 66.0,
              "notHelpful": 32.0
            },
            "at": null
          }
        },
        {
          "x": "2026-10-12",
          "value": 57.0,
          "extras": {
            "n": 76,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": {
              "helpful": 57.0,
              "notHelpful": 19.0
            },
            "at": null
          }
        },
        {
          "x": "2026-10-19",
          "value": 68.0,
          "extras": {
            "n": 104,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": {
              "helpful": 68.0,
              "notHelpful": 36.0
            },
            "at": null
          }
        },
        {
          "x": "2026-10-26",
          "value": 59.0,
          "extras": {
            "n": 86,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": {
              "helpful": 59.0,
              "notHelpful": 27.0
            },
            "at": null
          }
        }
      ],
      "extras": {
        "n": null,
        "nStudents": null,
        "tooFew": null,
        "weekly": null,
        "p20": null,
        "p80": null,
        "parts": null,
        "at": null
      }
    },
    {
      "name": "vote_rate:week",
      "shape": "points",
      "unit": "%",
      "axis": "week",
      "value": [
        {
          "x": "2026-08-03",
          "value": 25.0,
          "extras": {
            "n": 288,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": null
          }
        },
        {
          "x": "2026-08-10",
          "value": 27.77777777777778,
          "extras": {
            "n": 324,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": null
          }
        },
        {
          "x": "2026-08-17",
          "value": 23.333333333333332,
          "extras": {
            "n": 360,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": null
          }
        },
        {
          "x": "2026-08-24",
          "value": 33.33333333333333,
          "extras": {
            "n": 288,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": null
          }
        },
        {
          "x": "2026-08-31",
          "value": 24.691358024691358,
          "extras": {
            "n": 324,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": null
          }
        },
        {
          "x": "2026-09-07",
          "value": 30.555555555555557,
          "extras": {
            "n": 360,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": null
          }
        },
        {
          "x": "2026-09-14",
          "value": 24.305555555555554,
          "extras": {
            "n": 288,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": null
          }
        },
        {
          "x": "2026-09-21",
          "value": 30.864197530864196,
          "extras": {
            "n": 324,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": null
          }
        },
        {
          "x": "2026-09-28",
          "value": 21.666666666666668,
          "extras": {
            "n": 360,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": null
          }
        },
        {
          "x": "2026-10-05",
          "value": 34.02777777777778,
          "extras": {
            "n": 288,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": null
          }
        },
        {
          "x": "2026-10-12",
          "value": 23.456790123456788,
          "extras": {
            "n": 324,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": null
          }
        },
        {
          "x": "2026-10-19",
          "value": 28.888888888888886,
          "extras": {
            "n": 360,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": null
          }
        },
        {
          "x": "2026-10-26",
          "value": 29.86111111111111,
          "extras": {
            "n": 288,
            "nStudents": null,
            "tooFew": false,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": null
          }
        }
      ],
      "extras": {
        "n": null,
        "nStudents": null,
        "tooFew": null,
        "weekly": null,
        "p20": null,
        "p80": null,
        "parts": null,
        "at": null
      }
    },
    {
      "name": "thumbs_down_reasons",
      "shape": "list",
      "unit": "count",
      "value": [
        {
          "key": "Missed the question",
          "label": "Missed the question",
          "value": 126.0,
          "extras": {
            "n": null,
            "nStudents": null,
            "tooFew": null,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": "2026-10-26"
          }
        },
        {
          "key": "Too vague",
          "label": "Too vague",
          "value": 121.0,
          "extras": {
            "n": null,
            "nStudents": null,
            "tooFew": null,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": "2026-10-26"
          }
        },
        {
          "key": "Wrong focus",
          "label": "Wrong focus",
          "value": 120.0,
          "extras": {
            "n": null,
            "nStudents": null,
            "tooFew": null,
            "weekly": null,
            "p20": null,
            "p80": null,
            "parts": null,
            "at": "2026-10-26"
          }
        }
      ],
      "extras": {
        "n": null,
        "nStudents": null,
        "tooFew": null,
        "weekly": null,
        "p20": null,
        "p80": null,
        "parts": null,
        "at": null
      }
    }
  ]
}
